import { render } from "./Booking_Company.vue?vue&type=template&id=5f99981e&scoped=true"
import script from "./Booking_Company.vue?vue&type=script&lang=js"
export * from "./Booking_Company.vue?vue&type=script&lang=js"

import "./Booking_Company.vue?vue&type=style&index=0&id=5f99981e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f99981e"

export default script